<template>
    <div>
        <button
            @click="open"
            class="mt-2 py-1 ml-4 px-2 border border-gray-300 shadow-sm text-sm rounded-md text-gray-700 font-medium hover:bg-gray-100"
        >
            <i class="fa fa-pencil" aria-hidden="true"></i>
            Edit
        </button>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header"> Editieren</template>

                <input-text v-model="name" class="mt-4"> Bookable Name </input-text>
                <input-text v-model="name_en" class="mt-4">
                    Bookable Name Englisch
                    <template slot="helper">
                        Englische Übersetzung bei Bedarf eingeben.
                    </template>
                </input-text>

                <div class="my-4">
                    <h2 class="text-gray-700 font-medium text-sm mb-1">Icon</h2>
                    <ul class="flex">
                        <li v-for="ic in icons" class="inline-block">
                            <a
                                @click="icon = ic"
                                class="block p-4 border rounded-md"
                                :class="{ 'border-blue-500': ic === icon }"
                            >
                                <i class="fa fa-fw" :class="ic"></i>
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="flex justify-between">
                    <button
                        @click="deleteCategory"
                        class="mt-4 py-1 px-2 border border-gray-300 shadow-sm text-sm rounded-md text-gray-700 font-medium hover:bg-gray-100"
                    >
                        <i class="fa fa-trash" aria-hidden="true"></i>
                        Löschen
                    </button>

                    <button
                        class="mt-4 px-4 py-2 item-center border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-secondary focus:outline-none"
                        @click="confirm"
                    >
                        <i class="fa fa-floppy-o" aria-hidden="true"></i>
                        Speichern
                    </button>
                </div>
            </modal>
        </portal>
    </div>
</template>


<script>
import Modal from "../Modal";
import InputText from "../UI/InputText.vue";

export default {
    name: "BookableCategorySingleEdit",
    components: {
        Modal,
        InputText,
    },
    props: ["category","icons"],

    data: () => ({
        showModal: false,
        name: "",
        name_en: "",
        icon: "",
    }),

    methods: {
        open() {
            this.showModal = true;
            this.name = this.category.name;
            this.name_en = this.category.name_en;
            this.icon = this.category.icon;
        },

        deleteCategory() {
            window.axios
                .post(`/super/bookable_categories/${this.category.id}`, {
                    _method: "DELETE",
                })
                .then(() => {
                    location.reload();
                })
                .catch(() => {
                    alert("Löschen fehlgeschlagen");
                });
        },


        confirm() {
            this.$http
                .post(`/super/bookable_categories/${this.category.id}`, {
                    _method: "put",
                    name: this.name,
                    name_en: this.name_en,
                    icon: this.icon,
                })
                .then(() => {
                    location.reload();
                })
                .catch(function () {
                    alert("nicht ok");
                });
        },
    },
};
</script>